<template>
    <el-card shadow="always">
      <el-page-header @back="back" title :content="title"></el-page-header>
    </el-card>
</template>

<script>
export default {
  name: "ShippingHeaderAdd",
  props: ['title'],
  methods: {
    back() {
      this.$emit("back");
    }
  }
}
</script>
